import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const searchInputWrapper = css`
  position: relative;
`

export const breadcrumb = css`
  display: flex;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const breadcrumbItem = (theme: Theme) => css`
  flex-shrink: 0;
  text-overflow: ellipsis;
  /* Crumb separator */
  &:not(:first-of-type) {
    margin-left: ${size[8]};

    &::before {
      content: '';
      display: inline-block;
      margin-right: ${size[8]};
      border-right: 1px solid ${theme.palette.ghost.mediumContrast};
      transform: rotate(20deg);
      height: 1em;
      vertical-align: middle;
    }
  }
`
